module.exports = __webpack_public_path__ + "img/loja.690e75a6.svg";